import { getCookie, setCookie } from "./cookies";
import { cookies, requiredCookies } from "./cookieTypes";
import { defaultContent, gtag } from "./datalayer.consent";
export const getCookieStatus = ()=>getCookie("cookies") === "accepted" ? "accepted" : getCookie("cookies") === "denied" ? "denied" : "not_touched";
export const acceptCookies = ()=>{
    setCookie("cookies", "accepted", 1000);
    const cookies = new Map([
        [
            'functional-cookies',
            'yes'
        ],
        [
            'analytical-cookies',
            'yes'
        ],
        [
            'video-cookies',
            'yes'
        ],
        [
            'tracking-cookies',
            'no'
        ]
    ]);
    setConsentCookie(cookies);
};
export const denyCookies = ()=>{
    setCookie("cookies", "denied", 1000);
    const cookies = new Map([
        [
            'functional-cookies',
            'yes'
        ],
        [
            'analytical-cookies',
            'yes'
        ],
        [
            'video-cookies',
            'no'
        ],
        [
            'tracking-cookies',
            'no'
        ]
    ]);
    setConsentCookie(cookies);
};
const cookieToModeMapping = {
    'analytical-cookies': [
        'analytics_storage'
    ],
    'functional-cookies': [
        'functionality_storage',
        'security_storage'
    ],
    'video-cookies': [],
    'tracking-cookies': [
        'personalization_storage',
        'ad_personalization',
        'ad_storage',
        'ad_user_data'
    ]
};
export const getCurrentCookies = ()=>new Map(cookies.map((cookie)=>[
            cookie,
            getCookie(cookie) === 'yes' || requiredCookies.includes(cookie) ? 'yes' : 'no'
        ]));
export const updateConsent = (cookies)=>{
    const data = defaultContent;
    cookies.forEach((isAccepted, cookie)=>{
        var modes = cookieToModeMapping[cookie];
        modes.forEach((mode)=>data[mode] = isAccepted == 'yes' ? 'granted' : 'denied');
    });
    gtag('consent', 'update', data);
};
export const setConsentCookie = (cookies)=>{
    updateConsent(cookies);
    cookies.forEach((isAccepted, cookie)=>setCookie(cookie, isAccepted, 1000));
};
export function updateInitialConsent() {
    updateConsent(getCurrentCookies());
}
window.updateInitialConsent = updateInitialConsent;
